// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";

// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);



Vue.config.productionTip = false

Vue.prototype.$axios = axios; //全局注册，使用方法为:this.$axios
Vue.prototype.$echarts = echarts

// axios
const service = axios.create({
	baseURL: process.env.BASE_API, // api的base_url
	timeout: 100000, // request timeout
	withCredentials: false
})
let reqNum = 0;
const startLoading = () => {
	if (reqNum === 0) {
		//loading开始
		store.commit('routers/loadingset', true);
	}
	reqNum++;
};
const endLoading = () => {
	if (reqNum <= 0) return;
	reqNum--;
	if (reqNum === 0) {
		//loading结束
		store.commit('routers/loadingset', false);
	}
};

service.interceptors.request.use(
	config => {
		startLoading()
		config.headers = {
			'Authorization': localStorage.getItem('szToken'),
			'Accept': 'application/json',
			'Content-Type': 'application/json;charset=UTF-8',
			'tenant-id': 1
		}
		return config;
	},
	error => {
		Promise.reject(error)
	})

service.interceptors.response.use(response => {
	endLoading();
	
	if (response.data.code == 401) {
		service({
			method: 'post', // 方法
			url: '/member/auth/refresh-token',
			params:{
				refreshsToken: localStorage.getItem('refreshsToken')
			},		
		}).then(res => {
			if(res.data.code == 400){
				router.replace('/login')
				return
			}
			localStorage.setItem('jxsTokens',res.data.data.accessToken)
			localStorage.setItem('refreshsToken',res.data.data.refreshsToken)
			router.replace('/login')
			location.reload()
		})
		return Promise.reject('未登录或登录已过期')
	} else {
		return response
	}
}, error => {
	return Promise.reject(error.response.data) // 返回接口返回的错误信息
})
Vue.prototype.$service = service;

// 路由器切换回到顶部
router.beforeEach((to, from, next) => {
    // chrome
    document.getElementById('app').scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
});



/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js